/* HART · the rack (sections/hart-rack.liquid)
   Two hangers, "Your Look" and "Their Look". Each picks its own color and size; "Exact match" links the colors.
   Front/Back turns both hoodies. A silver point opens a close-up of that detail on that hoodie. "Add Both to Bag"
   adds the two exact variants to the Shopify cart in one request, as two lines that say whose look each one is,
   then tells the theme's cart drawer so it refreshes and opens (the same way as Build Your Match). */

const reduced = () => { try { return matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; } };

async function events() {
  try { return await import('@shopify/events'); } catch (e) { return null; }
}

function init(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = '1';

  const live = root.dataset.live === 'true';
  const labels = [root.dataset.label1 || 'Your Look', root.dataset.label2 || 'Their Look'];
  const prop = root.dataset.property || '';
  let data = {};
  try { data = JSON.parse(root.querySelector('[data-rack-data]').textContent); } catch (e) {}
  const colors = data.colors || [];
  const details = data.details || {};
  const mock = data.mock || '';
  if (!colors.length) return;
  const colorOf = (h) => colors.find((c) => c.handle === h) || colors[0];

  const state = {
    mode: root.dataset.startMode === 'exact' ? 'exact' : 'coord',
    side: 'front',
    looks: [{ color: colorOf(root.dataset.c0).handle, size: '' }, { color: colorOf(root.dataset.c1).handle, size: '' }],
    detail: null,
  };

  function variantFor(colorHandle, size) {
    const c = colors.find((x) => x.handle === colorHandle);
    if (!c || !c.variants || !c.variants.length) return null;
    return c.variants.find((v) => !v.size || v.size === size) || null;
  }
  function sizeAvailable(colorHandle, size) {
    if (!live) return true;
    const v = variantFor(colorHandle, size);
    return !!(v && v.available);
  }

  const hangers = [0, 1].map((i) => root.querySelector('[data-hanger="' + i + '"]'));
  const panels = [0, 1].map((i) => root.querySelector('[data-look="' + i + '"]'));
  const box = root.querySelector('[data-detail]');
  const status = root.querySelector('[data-status]');
  const summary = root.querySelector('[data-summary]');
  const kind = root.querySelector('[data-kind]');

  function syncHanger(i) {
    const h = hangers[i];
    if (!h) return;
    const c = colorOf(state.looks[i].color);
    h.querySelectorAll('[data-layer]').forEach((l) => l.classList.toggle('is-on', l.dataset.layer === c.handle));
    const a = h.querySelector('[data-pic]');
    if (a) {
      a.href = c.url;
      a.setAttribute('aria-label', labels[i] + ': ' + c.piece + ' in ' + c.name + ', ' + c.price + '. Opens its product page.');
    }
    const dots = h.querySelector('[data-dots]');
    if (dots) dots.hidden = !c.closeups;
    h.querySelectorAll('[data-dot]').forEach((d) => {
      const on = !!state.detail && state.detail.look === i && state.detail.part === d.dataset.dot;
      d.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
  }

  function syncPanel(i) {
    const p = panels[i];
    if (!p) return;
    const s = state.looks[i];
    const c = colorOf(s.color);
    p.querySelectorAll('[data-color]').forEach((r) => { r.checked = r.value === s.color; });
    const link = p.querySelector('[data-look-link]');
    if (link) { link.href = c.url; link.textContent = c.name + ', ' + c.price; }
    if (s.size && !sizeAvailable(s.color, s.size)) s.size = '';
    p.querySelectorAll('[data-size]').forEach((r) => {
      const out = !sizeAvailable(s.color, r.value);
      r.disabled = out;
      r.parentNode.classList.toggle('is-out', out);
      r.checked = r.value === s.size;
    });
    const sv = p.querySelector('[data-sval]');
    if (sv) sv.textContent = s.size;
  }

  function syncDetail() {
    if (!box) return;
    const d = state.side === 'front' ? state.detail : null;
    const c = d ? colorOf(state.looks[d.look].color) : null;
    const cu = c && c.closeups ? c.closeups[d.part] : null;
    const info = d ? details[d.part] : null;
    if (!d || !cu || !info) { box.hidden = true; return; }
    const img = box.querySelector('[data-detail-img]');
    if (img) {
      img.src = cu.l;
      img.srcset = cu.s + ' 538w, ' + cu.l + ' 1076w';
      img.alt = info.alt + ', ' + c.name.toLowerCase() + mock;
    }
    const who = box.querySelector('[data-detail-who]'); if (who) who.textContent = labels[d.look] + ' · ' + c.name + ' · ' + info.name;
    const t = box.querySelector('[data-detail-title]'); if (t) t.textContent = info.title;
    const x = box.querySelector('[data-detail-text]'); if (x) x.textContent = info.text;
    box.hidden = false;
  }

  function lineFor(i) {
    const s = state.looks[i];
    const frag = document.createDocumentFragment();
    frag.append(labels[i] + ': ' + colorOf(s.color).name + ', ');
    if (s.size) frag.append(s.size);
    else { const em = document.createElement('em'); em.textContent = 'size not chosen'; frag.append(em); }
    return frag;
  }

  function syncAll() {
    root.querySelectorAll('[data-mode]').forEach((b) => b.setAttribute('aria-pressed', b.dataset.mode === state.mode ? 'true' : 'false'));
    root.querySelectorAll('[data-side]').forEach((b) => b.setAttribute('aria-pressed', b.dataset.side === state.side ? 'true' : 'false'));
    root.classList.toggle('is-back', state.side === 'back');
    if (kind) kind.textContent = state.looks[0].color === state.looks[1].color ? 'Exact match' : 'Coordinated';
    [0, 1].forEach((i) => { syncHanger(i); syncPanel(i); });
    if (summary) { summary.textContent = ''; summary.append(lineFor(0), ' · ', lineFor(1)); }
    syncDetail();
  }

  function say(msg, bad) {
    if (!status) return;
    status.textContent = msg;
    status.classList.toggle('is-err', !!bad);
  }

  root.addEventListener('click', (e) => {
    const t = e.target.closest('button');
    if (!t || !root.contains(t)) return;
    if (t.dataset.mode) {
      state.mode = t.dataset.mode === 'exact' ? 'exact' : 'coord';
      if (state.mode === 'exact') state.looks[1].color = state.looks[0].color;
      else if (state.looks[0].color === state.looks[1].color && colors.length > 1) {
        const k = colors.findIndex((c) => c.handle === state.looks[0].color);
        state.looks[1].color = colors[(k + 1) % colors.length].handle;
      }
      say('');
      syncAll();
    } else if (t.dataset.side) {
      state.side = t.dataset.side === 'back' ? 'back' : 'front';
      syncAll();
    } else if (t.dataset.dot) {
      const h = t.closest('[data-hanger]');
      const look = h ? +h.dataset.hanger : 0;
      const same = state.detail && state.detail.look === look && state.detail.part === t.dataset.dot;
      state.detail = same ? null : { look, part: t.dataset.dot, from: t };
      syncAll();
      if (!same && box && !box.hidden) {
        const r = box.getBoundingClientRect();
        if (r.bottom > innerHeight || r.top < 0) box.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'nearest' });
      }
    } else if (t.hasAttribute('data-detail-close')) {
      const from = state.detail && state.detail.from;
      state.detail = null;
      syncAll();
      if (from && from.isConnected) from.focus();
    }
  });

  if (box) box.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const from = state.detail && state.detail.from;
    state.detail = null;
    syncAll();
    if (from && from.isConnected) from.focus();
  });

  root.addEventListener('change', (e) => {
    const t = e.target;
    const look = t.closest('[data-look]');
    if (!look) return;
    const i = +look.dataset.look;
    if (t.matches('[data-color]')) {
      state.looks[i].color = t.value;
      if (state.mode === 'exact') state.looks[1 - i].color = t.value;
      say('');
      syncAll();
    } else if (t.matches('[data-size]')) {
      state.looks[i].size = t.value;
      const err = look.querySelector('[data-size-err]'); if (err) err.hidden = true;
      say('');
      syncAll();
    }
  });

  const btn = root.querySelector('[data-add]');
  if (btn) btn.dataset.label = btn.textContent.trim();
  if (btn) btn.addEventListener('click', async () => {
    say('');
    if (!live) { say('This becomes live once the hoodies are added in Shopify.', true); return; }
    const missing = [0, 1].filter((i) => !state.looks[i].size);
    if (missing.length) {
      missing.forEach((i) => {
        const err = panels[i] && panels[i].querySelector('[data-size-err]');
        if (err) { err.textContent = 'Choose a size for ' + labels[i] + '.'; err.hidden = false; }
      });
      say(missing.length > 1 ? 'Choose a size for each look first.' : 'Choose a size for ' + labels[missing[0]] + ' first.', true);
      const first = panels[missing[0]] && panels[missing[0]].querySelector('[data-size]:not([disabled])');
      if (first) first.focus({ preventScroll: false });
      return;
    }
    const items = [0, 1].map((i) => {
      const v = variantFor(state.looks[i].color, state.looks[i].size);
      if (!v || !v.available) return null;
      const it = { id: v.id, quantity: 1 };
      if (prop) it.properties = { [prop]: labels[i] };
      return it;
    });
    if (items.some((x) => !x)) { say('One of those choices is not available. Try another size or color.', true); return; }

    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    const ev = await events();
    const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
      .map((el) => el.dataset.sectionId).filter(Boolean);
    let deferred = null;
    if (ev && ev.CartLinesUpdateEvent && ev.CartLinesUpdateEvent.createPromise) {
      deferred = ev.CartLinesUpdateEvent.createPromise();
      root.dispatchEvent(new ev.CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: items.map((x) => ({ merchandiseId: String(x.id), quantity: 1 })),
        promise: deferred.promise,
      }));
    }
    const routes = (window.Theme && window.Theme.routes) || {};
    const addUrl = root.dataset.addUrl || routes.cart_add_url || '/cart/add';
    const cartUrl = root.dataset.cartUrl || routes.cart_url || '/cart';
    try {
      const res = await fetch(addUrl + (addUrl.endsWith('.js') ? '' : '.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: sectionIds.join(',') }),
      });
      const added = await res.json();
      const cart = await (await fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })).json();
      if (added.status) {
        say(added.description || added.message || 'Those hoodies could not be added. Try again.', true);
        if (deferred) deferred.resolve({ cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { didError: true, items: cart.items, source: 'hart-rack' } });
        return;
      }
      if (deferred) {
        deferred.resolve({
          cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: { items: cart.items, source: 'hart-rack', sourceId: root.id, itemCount: 2, sections: added.sections, didError: false },
        });
      }
      btn.classList.add('is-done');
      btn.textContent = 'Added to Bag';
      say(root.dataset.set ? 'Both are in your bag. The matching set price comes off there.' : 'Both are in your bag.');
      setTimeout(() => { btn.classList.remove('is-done'); btn.textContent = btn.dataset.label || 'Add Both to Bag'; }, 2600);
      if (!deferred || !document.querySelector('cart-drawer-component')) location.href = cartUrl;
    } catch (e) {
      if (deferred) deferred.reject(e);
      say('Your bag could not be reached. Check your connection and try again.', true);
    } finally {
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
    }
  });

  syncAll();
}

function boot() { document.querySelectorAll('[data-rack]').forEach(init); }
boot();
document.addEventListener('shopify:section:load', boot);